<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Code d'Engagement" />
            <CodeEngagement />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import CodeEngagement from '../CodeEngagement/CodeEngagement.vue'

export default {
    name: 'CodeEngagementPage',
    components: {
        NavBar,
        PageTitle,
        CodeEngagement,
        FooterComp,
    }
}
</script>